import { getResolvedRef } from './get-resolved-ref.js';
/**
 * Iterate through all available servers and pick the first one
 *
 * @example
 * getFirstServer(operation.servers, pathItem.servers, document.servers)
 */
export const getFirstServer = (...availableServers) => {
    for (const serverSource of availableServers) {
        if (!serverSource) {
            continue;
        }
        // Handle single server object
        if (!Array.isArray(serverSource)) {
            const resolvedServer = getResolvedRef(serverSource);
            if (resolvedServer?.url) {
                return resolvedServer;
            }
            continue;
        }
        // Handle array of servers, pick the first one with a URL
        for (const server of serverSource) {
            const resolvedServer = getResolvedRef(server);
            if (resolvedServer?.url) {
                return resolvedServer;
            }
        }
    }
    return null;
};
